/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  queryParams = {
    outstanding: {
      refreshModel: true,
    },
    year: {
      refreshModel: true,
    },
  };

  // Services
  @service
  features;

  @service
  store;

  model(params) {
    if (isEmpty(params.year)) {
      params.year = moment().year();
    }
    params.community = true;
    params.include = 'transactions';

    let promises = {
      items: this.store.query('finance/line-item', params),
      ledgerItems: this.store.query('finance/ledger-item', {
        year: params.year,
      }),
      futureLedgerItems: this.store.query('finance/ledger-item', {
        year: moment().year() + 1,
      }),
      ledgers: this.store.findAll('finance/ledger'),
    };

    if (this.features.sapFinance) {
      // Add extra SAP entities if required.
      promises.costCentres = this.store.findAll('finance/cost-centre');
      promises.internalOrders = this.store.findAll('finance/internal-order');
    }

    return hash(promises);
  }

  setupController() {
    super.setupController(...arguments);
    this.controller.set(
      'hideArchivedLineItems',
      this.controller.get('personOptions.hideArchivedLineItems'),
    );
  }
}
